/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
/**
 * 
 * @export
 * @interface LocalProfilePreviewReview
 */
export interface LocalProfilePreviewReview {
    /**
     * 
     * @type {boolean}
     * @memberof LocalProfilePreviewReview
     */
    viewerHasReview: boolean;
    /**
     * 
     * @type {string}
     * @memberof LocalProfilePreviewReview
     */
    targetUri: string;
}

/**
 * Check if a given object implements the LocalProfilePreviewReview interface.
 */
export function instanceOfLocalProfilePreviewReview(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "viewerHasReview" in value;
    isInstance = isInstance && "targetUri" in value;

    return isInstance;
}

export function LocalProfilePreviewReviewFromJSON(json: any): LocalProfilePreviewReview {
    return LocalProfilePreviewReviewFromJSONTyped(json, false);
}

export function LocalProfilePreviewReviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalProfilePreviewReview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'viewerHasReview': json['viewer_has_review'],
        'targetUri': json['target_uri'],
    };
}

export function LocalProfilePreviewReviewToJSON(value?: LocalProfilePreviewReview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'viewer_has_review': value.viewerHasReview,
        'target_uri': value.targetUri,
    };
}

